import styled from 'styled-components';
import { common } from 'themes/default';

export const DetailsContainer = styled.div`
  margin: 10px 0 0 0;
  width: inherit;

  * {
    box-sizing: border-box;
  }

  > * {
    margin: 0 0 10px 0;
  }

  .pagination {
    align-items: center;
    display: flex;
    justify-content: center;
    list-style: none;
    margin: 0 0 20px 0;
    padding-left: 0;
  }

  .page-item {
    height: 3rem;
    width: 3rem;

    &:first-child .page-link {
      margin-left: 0;
    }
  }

  .page-link {
    align-items: center;
    background-color: ${common.pagination.normal.backgroundColour};
    border: 0.125rem solid ${common.pagination.normal.borderColour};
    border-radius: 0.25rem;
    color: ${common.pagination.normal.fontColour};
    cursor: pointer;
    display: flex;
    font-weight: normal;
    height: 100%;
    justify-content: center;
    outline: none;
    position: relative;
    width: 100%;
    text-decoration: none;

    &:hover {
      background-color: ${common.pagination.hover.backgroundColour};
      border-color: ${common.pagination.hover.borderColour};
      color: ${common.pagination.hover.fontColour};
      text-decoration: underline;
      z-index: 2;
    }

    &:active,
    &:focus-visible {
      background-color: ${common.pagination.focus.backgroundColour};
      border-color: ${common.pagination.focus.borderColour};
      color: ${common.pagination.focus.fontColour};
      z-index: 3;
    }

    /* Active */
    &[aria-current='page'] {
      color: ${common.pagination.active.fontColour};
      background-color: ${common.pagination.active.backgroundColour};
      border-color: ${common.pagination.active.borderColour};
      font-weight: bold;
      z-index: 3;

      &:active,
      &:focus-visible {
        border-color: ${common.pagination.activeFocus.borderColour};
        outline: 0.125rem solid ${common.pagination.activeFocus.outlineColour};
      }
    }

    /* Disabled */
    &[aria-disabled='true'] {
      pointer-events: none;
      color: ${common.pagination.disabled.fontColour};
      background-color: ${common.pagination.disabled.backgroundColour};
      border-color: ${common.buttons.disabled.borderColour};
      cursor: not-allowed;
    }
  }
`;
